import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc92aa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup edit" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = { class: "popup-content small-padding" }
const _hoisted_5 = { class: "options" }
const _hoisted_6 = { class: "option" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = { class: "option" }
const _hoisted_9 = { class: "option" }
const _hoisted_10 = { class: "option" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "popup-footer" }
const _hoisted_13 = { class: "btn btn-primary" }

import PopupCancelButton from "@/components/popup/PopupCancelButton.vue";
import Icon from "../icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupNotificationsSetting',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.header")), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Icon, {
            icon: _unref(IconType).RING
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.optionSound")), 1),
          _createVNode(Icon, {
            icon: _unref(IconType).CHECKBOX_ON,
            class: "icon"
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Icon, {
            icon: _unref(IconType).NOTIFICATIONS
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.optionNotifications")), 1),
          _createVNode(Icon, {
            icon: _unref(IconType).CHECKBOX_ON,
            class: "icon"
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Icon, {
            icon: _unref(IconType).SAMPLES
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.optionPreviews")), 1),
          _createVNode(Icon, {
            icon: _unref(IconType).CHECKBOX_ON,
            class: "icon"
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Icon, {
            icon: _unref(IconType).NO_NOTIFY_BLACK
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.optionNoNotifications")), 1),
          _createVNode(Icon, {
            icon: _unref(IconType).CHECKBOX_ON,
            class: "icon"
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Icon, {
            icon: _unref(IconType).CALLS
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.optionRing")), 1),
          _createVNode(Icon, {
            icon: _unref(IconType).CHECKBOX_ON,
            class: "icon"
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createVNode(PopupCancelButton),
      _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t("popup.PopupNotificationsSetting.btnSave")), 1)
    ])
  ]))
}
}

})